// Import model
import { LeadCondition } from '../models/LeadCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { LeadIndexedFields } from '../models/LeadIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { LeadIndexedFieldsSerializer } from './LeadIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for LeadCondition - handles JSON serialization and deserialization with type validation
 */
export class LeadConditionSerializer {
  /**
   * Deserializes a JSON string into a LeadCondition instance
   */
  static deserialize(json: string): LeadCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a LeadCondition instance
   */
  static fromObject(obj: any): LeadCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to LeadCondition');
    }


    const instance: LeadCondition = {
      fieldName: obj['fieldName'] as LeadIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of LeadCondition instances
   */
  static deserializeArray(json: string): LeadCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a LeadCondition instance to a JSON string
   */
  static serialize(instance: LeadCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a LeadCondition instance to a plain object
   */
  static toObject(instance: LeadCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of LeadCondition instances to a JSON string
   */
  static serializeArray(instances: LeadCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
